import Vue from 'vue';
import * as types from '../mutation-types';

const firstTime = true || document.cookie.indexOf('visited') < 0;
const onlyWhite = window.location.pathname.indexOf('white') > -1;
const langEng = window.location.pathname.indexOf('eng/') > -1;

// initial state
const state = {
  animation: false,
  loaded: false,
  page: {},
  lang: langEng ? 1 : 0,
  firstVisit: firstTime,
  firstVisitAnimation: firstTime && location.pathname === '/',
  themeSwitchingEnding: false,
  themeIsSwitched: false,
  theme: firstTime && !onlyWhite ? 'dark' : 'white',
  themeOnlyWhite: onlyWhite,
};

// getters
const getters = {
  page: stateFreezed => stateFreezed.page,
  theme: stateFreezed => stateFreezed.theme,
  themeOnlyWhite: stateFreezed => stateFreezed.themeOnlyWhite,
  themeIsSwitched: stateFreezed => stateFreezed.themeIsSwitched,
  themeSwitchingEnding: stateFreezed => stateFreezed.themeSwitchingEnding,
  lang: stateFreezed => stateFreezed.lang,
  loaded: stateFreezed => stateFreezed.loaded,
  animation: stateFreezed => stateFreezed.animation,
  firstVisit: stateFreezed => stateFreezed.firstVisit,
  firstVisitAnimation: stateFreezed => stateFreezed.firstVisitAnimation,
};

// actions
const actions = {
  fetchPage({ commit, dispatch }, params) {
    Vue.http.get(`/${params.lang}/pages/`)
    .then((response) => {
      // get body data
      commit(types.RECEIVE_PAGE, response.bodyText);
    });
  },
  changeTheme({ commit }, theme) {
    commit(types.THEME_SWITCHING_END, false);
    commit(types.CHANGE_THEME, theme);
    setTimeout(() => {
      commit(types.THEME_SWITCHING_END, true);
    }, 1500);

    const links = document.querySelectorAll('.favicon');

    if (links && links.length) {
      for (let link = 0; link < links.length; link += 1) {
        if (links[link] && links[link].href) {
          if (theme === 'white') {
            links[link].href = links[link].href.replace('-dark', '');
          } else if (links[link].href.indexOf('dark') < 0) {
            links[link].href = links[link].href.replace('favicon-', 'favicon-dark-');
          }
        }
      }
    }
  },
  pageIsLoaded({ commit }) {
    commit(types.PAGE_LOADED);
    setTimeout(() => {
      commit(types.PAGE_ANIMATION);
    }, 1500);
  },
  firstVisitTimeout({ commit }) {
    setTimeout(() => {
      commit(types.CHANGE_THEME, 'white');
      setTimeout(() => {
        commit(types.PAGE_ANIMATION_FIRST_VISIT, false);
      }, 3000);
    }, 5000);
  },
};

// mutations
const mutations = {
  [types.RECEIVE_PAGE](stateFreezed, pageFetched) {
    const st = stateFreezed;
    st.page = JSON.parse(pageFetched).content;
  },
  [types.CHANGE_THEME](stateFreezed, theme) {
    const st = stateFreezed;
    st.theme = theme;
  },
  [types.THEME_ONLY_WHITE](stateFreezed, status) {
    const st = stateFreezed;
    st.themeOnlyWhite = status;
  },
  [types.THEME_SWITCHING_END](stateFreezed, theme) {
    const st = stateFreezed;
    st.themeSwitchingEnding = theme;
  },
  [types.THEME_SWITCHED](stateFreezed, theme) {
    const st = stateFreezed;
    st.themeIsSwitched = theme;
  },
  [types.PAGE_LOADED](stateFreezed) {
    const st = stateFreezed;
    st.loaded = true;
  },
  [types.PAGE_ANIMATION](stateFreezed) {
    const st = stateFreezed;
    st.animation = true;
  },
  [types.SWITCH_LANG](stateFreezed, lang) {
    const st = stateFreezed;
    st.lang = lang;
  },
  [types.PAGE_ANIMATION_FIRST_VISIT](stateFreezed, status) {
    const st = stateFreezed;
    st.firstVisitAnimation = status;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/page.js